import { Button } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Button,
  React
};